<template>
    <div class="row" v-if="ready">
      <div class="col-md-4" v-if="!hide_select" >
        <div class="form-group">
          <label class>{{'Province'|translate}}</label>
          <select class="form-control" v-model="province_id" @change="onSelectProvince" required>
            <option disabled value>{{'Select province'|translate}}...</option>
            <option v-for="item in list_provinces" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4" v-if="list_districts && !hide_select">
        <div class="form-group">
          <label class>{{'District'|translate}}</label>
          <select
            class="form-control"
            v-if="list_districts"
            v-model="district_id"
            @change="onSelectDistrict"
            required
          >
            <option disabled value>{{'Select district'|translate}}...</option>
            <option v-for="item in list_districts" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select>
        </div>
      </div>

      <div class="col-md-4" v-if="list_communes && !hide_select">
        <div class="form-group">
          <label class>{{'Commune'|translate}}</label>
          <select
            class="form-control"
            v-if="list_communes"
            v-model="commune_id"
            required
            @change="onSelectCommune"
          >
            <option disabled value>{{'Select commune'|translate}}...</option>
            <option v-for="item in list_communes" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12 mt20" v-bind:style="{ display:  (commune_id || hide_select) && !hide_map ?  'initial':'none'  }" >

          <p>
            <strong>{{'Select your location on the map'|translate}}</strong>
          </p>
          <div class="wrap-map">
            <div id="map"></div>
          </div>

      </div>
    </div>
</template>

<script>
import Utils from '@/helpers/utils'
import Location from '@/helpers/location'
import Config from '@/helpers/config'
/* eslint-disable */
export default {
  name: "SelectLocation",
  props: ["province", "district", "commune", "p_location", "hide_select", "hide_map"],
  data() {
    return {
      ready: false,
      province_id: this.province ? this.province : "",
      district_id: this.district ? this.district: "" ,
      commune_id: this.commune ? this.commune : "",
      location: this.p_location,
      list_provinces: [],
      list_districts: [],
      list_communes: [],
      force_show_map: false,
      map: null,
      centerMarker: null
    };
  },

  methods: {
    getProvines() {
      Utils.getProvinces(this).then(data =>{
        
        this.list_provinces = data;
      })
    },
    onSelectProvince(e) {
      e.preventDefault();
      
      this.getDistricts();
    },
    getDistricts() {
      this.list_districts = [];
      this.list_communes = [];

      this.district_id = "";
      this.commune_id = "";
      this.location = null;
      this.updateLocation();
      this.getListDistricts();
    },
    getListDistricts() {
      Utils.requestV2(this).get(`listDistricts?province_id=` +  this.province_id).then(response => {
          this.list_districts = response.data;
          //console.log('this.list_districts',this.list_districts)
        });
    },
    onSelectDistrict() {
      
      this.getCommunes();
    },
    getCommunes() {
      this.list_communes = [];
      this.commune_id = "";
      this.location = null;
      //this.location = null
      this.updateLocation();
      this.getListCommune();
    },
    getListCommune() {

Utils.requestV2(this).get(`listCommunes?district_id=` +  this.district_id).then(response => {
          this.list_communes = response.data;
          //console.log('this.list_districts',this.list_districts)
        });
    },
    onSelectCommune() {
      this.commune_id = this.commune_id;
      this.updateLocation();
      setTimeout(() => {
        this.initMap();
      }, 100);
    },
    initMap() {
      console.log('init map');
      if (this.list_provinces.length == 0 || this.list_districts.length == 0 || this.list_communes.length == 0){
        return;
      }
      // var geocoder = new google.maps.Geocoder();
      let provice_name = Utils.getItemFromListById(
        this.list_provinces,
        this.province_id
      ).name;
      let district_name = Utils.getItemFromListById(
        this.list_districts,
        this.district_id
      ).name;
      let commune_name = Utils.getItemFromListById(
        this.list_communes,
        this.commune_id
      ).name;
      var address = `${commune_name},${district_name},${provice_name}`;
      // console.log("address", address);
      Location.getCoordinateFromAddress(address).then((position) => {
        console.log('position',position)

            this.location = position;
            console.log('this.location',this.location)
            this.updateLocation();
        
          this.renderMapFromLatLng(position);
      
      });
    },
    renderMapFromLatLng(position) {
        if (this.map == null){
          var platform = new H.service.Platform({
            apikey: Config.apiKeyHereMap
          });
          var defaultLayers = platform.createDefaultLayers();

          //Step 2: initialize a map - this map is centered over Europe
          this.map = new H.Map(document.getElementById('map'),
            defaultLayers.vector.normal.map,{
            center: position,
            zoom: 12,
            pixelRatio: window.devicePixelRatio || 1
          });


          // add a resize listener to make sure that the map occupies the whole container
          // window.addEventListener('resize', () => this.map.getViewPort().resize());

          //Step 3: make the map interactive
          // MapEvents enables the event system
          // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
          var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

          // Create the default UI components
          var ui = H.ui.UI.createDefault(this.map, defaultLayers);
      
          this.centerMarker = new H.map.DomMarker(position,  {volatility: true});
          // this.centerMarker.draggable = true;
          this.map.addObject(this.centerMarker);
          // console.log('add marker here', this.centerMarker)
      



          // this.map.addEventListener('dragstart', (ev)=> {
          //   var target = ev.target,
          //       pointer = ev.currentPointer;
          //   if (target instanceof H.map.Marker) {
          //     var targetPosition = this.map.geoToScreen(target.getGeometry());
          //     console.log('target.getGeometry()',target.getGeometry())


          //     target['offset'] = new H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y);
          //     behavior.disable();
          //   }
          // }, false);


          // // re-enable the default draggability of the underlying map
          // // when dragging has completed
          // this.map.addEventListener('dragend', (ev)=> {
          //   var target = ev.target;
          //   if (target instanceof H.map.Marker) {
          //     behavior.enable();
          //     this.location = target.getGeometry();
          //     console.log('this.location',this.location)
          //     this.updateLocation();
          //   }
          // }, false);

          // // Listen to the drag event and move the position of the marker
          // // as necessary
          // this.map.addEventListener('drag', (ev)=> {
          //   var target = ev.target,
          //       pointer = ev.currentPointer;
          //   if (target instanceof H.map.Marker) {
          //     target.setGeometry(this.map.screenToGeo(pointer.viewportX - target['offset'].x, pointer.viewportY - target['offset'].y));
          //   }
          // }, false);

          // this.map.addEventListener('mapviewchangeend', () => {
          //   console.log('mapviewchangeend')
          //   // return;
          
          //   // centerMarker.setGeometry(temp1.src.i.center)
          //   var position =this.map.getCenter();
          //   this.centerMarker.setGeometry(position)
          //   this.location = position;
          //   this.updateLocation();
          // });
          this.map.addEventListener('drag', (ev)=> {
              var position =this.map.getCenter();
              this.centerMarker.setGeometry(position)
          }, false);

          this.map.addEventListener('dragend', (ev)=> {
              
              var position =this.map.getCenter();
              this.centerMarker.setGeometry(position)
              this.location = position;
              this.updateLocation();
          }, false);
        }else{
          this.map.setCenter(position);
          this.centerMarker.setGeometry(position)
        }



    },
    updateLocation() {
      this.$emit("updateLocation", {
        province_id: this.province_id,
        district_id: this.district_id,
        commune_id: this.commune_id,
        location: this.location
      });
    }
  },
  mounted() {
    this.getProvines();
    if (this.district_id) {
      this.getListDistricts();
    } else {
      this.list_districts = [];
    }
    if (this.commune_id) {
      this.getListCommune();
    } else {
      this.list_communes = [];
    }


    // console.log('location2',this.location)
    if (this.location) {

      if (typeof this.location.lat == "undefined"){
        this.location = {
          lat : this.location[0],
          lng : this.location[1]
        }
      }
      console.log('location',location)
      setTimeout(() => {
        this.renderMapFromLatLng(this.location);
      }, 100);
    }
    this.ready = true;
   
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    if (this.map){
      // this.map.destroy();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/elements/SelectLocation.vue